import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-[#1E2A4A] shadow-md">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/solutions" className="text-white hover:text-orange-400 transition-colors">
              Solutions
            </Link>
            <Link to="/specialties" className="text-white hover:text-orange-400 transition-colors">
              Specialties
            </Link>
            <Link to="/platform" className="text-white hover:text-orange-400 transition-colors">
              Platform
            </Link>
            <Link to="/pricing" className="text-white hover:text-orange-400 transition-colors">
              Pricing
            </Link>
            <Link to="/resources" className="text-white hover:text-orange-400 transition-colors">
              Resources
            </Link>
            <div className="h-6 w-px bg-gray-400"></div>
            <Link to="/patient-portal" className="text-white hover:text-orange-400 transition-colors">
              Patient Portal
            </Link>
            <Link 
              to="/dentist-portal" 
              className="text-orange-400 font-medium hover:text-orange-300 transition-colors"
            >
              Dentist Portal
            </Link>
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Link 
              to="/schedule-demo" 
              className="px-6 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors"
            >
              Schedule Demo
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white hover:text-orange-400"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 space-y-2">
            <Link to="/solutions" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Solutions
            </Link>
            <Link to="/specialties" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Specialties
            </Link>
            <Link to="/platform" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Platform
            </Link>
            <Link to="/pricing" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Pricing
            </Link>
            <Link to="/resources" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Resources
            </Link>
            <div className="border-t border-gray-400 my-2"></div>
            <Link to="/patient-portal" className="block px-3 py-2 text-white hover:text-orange-400 transition-colors">
              Patient Portal
            </Link>
            <Link 
              to="/dentist-portal" 
              className="block px-3 py-2 text-orange-400 font-medium hover:text-orange-300 transition-colors"
            >
              Dentist Portal
            </Link>
            <div className="pt-4">
              <Link 
                to="/schedule-demo" 
                className="block px-3 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors text-center"
              >
                Schedule Demo
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 